import React from 'react';
import { DrawingInfo } from '../types';

interface DrawingInfoPanelProps {
  info: DrawingInfo;
  onChange: (info: DrawingInfo) => void;
}

const fields: { key: keyof DrawingInfo; label: string; type?: string }[] = [
  { key: 'panelType', label: '재질' },
  { key: 'panelSpec', label: '규격' },
  { key: 'wallHeight', label: '벽고' },
  { key: 'grooveInfo', label: '그루브' },
  { key: 'siteName', label: '거래처명' },
  { key: 'contact', label: '연락처' },
  { key: 'shipDate', label: '출고일', type: 'date' },
  { key: 'drawingNo', label: '작업No.' },
  { key: 'date', label: '날짜', type: 'date' },
  { key: 'drawnBy', label: '작성자' },
  { key: 'memo', label: '비고' },
];

const DrawingInfoPanel: React.FC<DrawingInfoPanelProps> = ({ info, onChange }) => {
  const handleChange = (key: keyof DrawingInfo, value: string) => {
    onChange({ ...info, [key]: value });
  };

  return (
    <div className="pd-card" style={{ marginTop: 10 }}>
      <h3 className="pd-title">도면 정보</h3>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px 8px' }}>
        {fields.map(f => (
          <div key={f.key} style={{ gridColumn: f.key === 'memo' || f.key === 'siteName' ? '1 / -1' : undefined }}>
            <label className="pd-label">{f.label}</label>
            <input type={f.type || 'text'} value={info[f.key]} onChange={e => handleChange(f.key, e.target.value)} className="pd-input sm" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default DrawingInfoPanel;
